import React, { useState } from 'react';

export const CoverImage = ({ src, alt, className = '' }) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#1e2a4a] to-[#0f1f35]" data-testid="cover-image-fallback">
        <span className="font-display text-[#e89b47]/40 tracking-widest text-xs">MARKETING TAROT</span>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={className}
      onError={() => setFailed(true)}
    />
  );
};
